import { useEffect, useRef, useState } from 'react'

import { ReactComponent as BookMark } from '../assets/icons/bookmark-icon.svg'
import { ReactComponent as Menu } from '../assets/icons/menu-overflow.svg'
import { ReactComponent as Edit } from '../assets/icons/edit.svg'
import { ReactComponent as Delete } from '../assets/icons/delete.svg'
import { ReactComponent as RightArrow } from '../assets/icons/next.svg'
import { DeleteModal } from './Modal'
import { deleteSessions } from '../apis/session.ts'
import { dayEnumList } from '../assets/data.js'
import { Link, useLocation } from 'react-router-dom'

export default function SessionCard({
  lesson,
  getSelectedCard,
  onStateChange,
  isNextSession,
  getSessionsApi,
  addState,
  editState,
  classData,
}) {
  // console.log(lesson)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()
  console.log(location.state)

  const menuRef = useRef()

  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMenuOpen(false)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [menuRef])

  const deleteSessionsApi = async () => {
    const deleteSessionsResponse = await deleteSessions({
      sessionId: lesson.id,
    })
    if (deleteSessionsResponse.error) {
      console.log(deleteSessionsResponse.message)
      return
    } else {
      console.log(deleteSessionsResponse.result)
      await getSessionsApi()
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }
  // console.log(isNextSession)
  return (
    <div className='w-full'>
      <div
        //   onClick={() => setIsLessonEdit((prev) => !prev)}
        className={`relative flex w-full justify-between rounded-16 border-[1px] border-solid px-20 py-16 ${
          addState || editState
            ? 'border-label-disable'
            : isNextSession
              ? 'border-border-active shadow-emphasize'
              : 'border-border-default'
        } `}
      >
        {isNextSession && (
          <div
            className={`absolute -top-4 right-[45px] ${addState || editState ? 'fill-label-disable stroke-label-disable' : 'fill-border-active stroke-border-active'}`}
          >
            <BookMark />
          </div>
        )}
        <div className='flex flex-col items-start gap-6'>
          <div className='flex items-center gap-12'>
            <p className='text-h1-medium text-label-strong'>{`${lesson.order}차시`}</p>
            <div className='h-[14px] w-[1px] bg-border-default' />
            <div className='flex items-center gap-4 text-body1-medium text-label-sub'>
              <p>{lesson.startDate}</p>
              <p>{dayEnumList[lesson.dayOfWeek]}</p>
              <p>{`${lesson.period}교시`}</p>
            </div>
          </div>
          <p className='text-body2-long-medium text-label-info'>{`${lesson.description ? lesson.description : ''}`}</p>
        </div>
        <div
          ref={menuRef}
          className={`flex flex-col items-end gap-6 ${addState || editState || lesson.status === 'COMPLETED' ? 'fill-label-disable' : 'fill-label-sub'}`}
        >
          <Menu
            className='pointer-events-auto cursor-pointer'
            onClick={() => {
              if (addState) return
              if (editState) return
              if (lesson.status === 'COMPLETED') return
              else {
                setIsMenuOpen((prev) => !prev)
              }
            }}
          />
          {isMenuOpen && (
            <div className='border_default absolute top-40 flex w-[150px] flex-col items-start gap-4 rounded-8 bg-background-default px-8 py-4 shadow-emphasize'>
              <div
                // onClick={onStateChange}
                onClick={() => {
                  onStateChange()
                  getSelectedCard(lesson.id)
                }}
                className='flex cursor-pointer items-center justify-center gap-4 px-8 py-4'
              >
                <Edit />
                <p className='text-body3-medium text-label-sub'>정보 수정</p>
              </div>
              <div
                onClick={openModal}
                className='flex cursor-pointer items-center justify-center gap-4 fill-status-negative px-8 py-4'
              >
                <Delete />
                <p className='text-body3-medium text-status-negative'>차시 삭제</p>
              </div>
            </div>
          )}
          <Link
            to={'/board'}
            state={{ sessionData: lesson, classData: location.state.data }}
            className={`gap-4 ${addState || editState ? 'button_outlined_assistive_disabled_sm fill-label-disable' : 'button_outlined_assistive_sm gap-4 fill-label-info text-label-info'}`}
          >
            {lesson.status === 'COMPLETED' ? '수업 내용 확인' : '수업 방 입장'}
            <RightArrow />
          </Link>
        </div>
      </div>
      {isModalOpen && (
        <DeleteModal
          close={closeModal}
          content={'lesson'}
          onStateChange={closeModal}
          deleteApi={() => deleteSessionsApi()}
          // getApi={getSessionsApi}
        />
      )}
    </div>
  )
}
